// Cheap "looks like an email" check for input validation.
// Used by group create/join + magic-link auth to validate optional email
// fields before sending them server-side.

export function looksLikeEmail(s: string): boolean {
  const t = s.trim();
  if (t.length < 5 || t.length > 254) return false;
  if (!t.includes('@')) return false;
  const at = t.lastIndexOf('@');
  if (at <= 0 || at === t.length - 1) return false;
  const domain = t.slice(at + 1);
  if (!domain.includes('.')) return false;
  if (/\s/.test(t)) return false;
  return true;
}
